import { apiRequest } from '../client'

/**
 * Per-restaurant kiosk screen branding (CHG-2026-08-kiosk-screen-branding).
 *
 * Mirrors the server shape in `KioskBranding`; the backend is the source of truth and validates it
 * (`KioskBrandingValidator`), so anything rejected here is also rejected there — never the reverse.
 */
export type BrandingColors = {
  background?: string
  text?: string
  accent?: string
}

export type BrandingAd = {
  /** A `media/<id>` reference, never a delivery URL — those are built per environment and width. */
  media: string
  durationSeconds?: number
  active: boolean
}

export type BrandingSurface = {
  enabled: boolean
  logo?: string
  colors?: BrandingColors
  target?: { width?: number; height?: number }
  ads?: Array<BrandingAd>
  /** Self-checkout only; ignored on the customer display, which is idle-driven. */
  attractDelaySeconds?: number
}

export type KioskBranding = {
  customerDisplay?: BrandingSurface
  selfCheckout?: BrandingSurface
}

export type SaveBrandingResponse = {
  branding: KioskBranding
  /** False when the save succeeded but the bundle publish did not — the config is stored either way. */
  published: boolean
  bundleId?: number
  version?: number
}

export const kioskBrandingApi = {
  get: (restaurantId: number) =>
    apiRequest<KioskBranding>(
      `/api/v0/admin/restaurants/${restaurantId}/kiosk-branding`,
    ),

  save: (restaurantId: number, body: KioskBranding) =>
    apiRequest<SaveBrandingResponse>(
      `/api/v0/admin/restaurants/${restaurantId}/kiosk-branding`,
      { method: 'PUT', body: JSON.stringify(body) },
    ),
}
